import { Property } from 'csstype'
import styled, { css } from 'styled-components'

import { MEDIA_QUERY } from '../../../../../styles'

export const InputsContainer = styled('div').withConfig({
  shouldForwardProp: (prop) => !['justifyContent', 'nestedFields'].includes(prop)
})<{ justifyContent?: Property.JustifyContent; nestedFields?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 30px;
  height: 100%;
  justify-content: ${({ justifyContent }) => justifyContent ?? 'flex-start'};
  ${({ nestedFields }) =>
    nestedFields &&
    css`
      padding-left: 20px;
      @media ${MEDIA_QUERY.MOBILE} {
        padding: 0;
      }
    `}
`
